import { useTranslation } from "react-i18next";
import { Container, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const CookiePolicy = () => {
  const { t } = useTranslation();

  const policyItems = [
    {
      id: "cookie_overview",
      heading: t("cookie_overview_heading", "Overview"),
      descriptionKey: "cookie_overview",
    },
    {
      id: "what_are_cookies",
      heading: t("what_are_cookies_heading", "What are cookies?"),
      descriptionKey: "what_are_cookies",
    },
    {
      id: "cookies_types",
      heading: t("cookies_types_heading", "Cookies Types"),
      descriptionKey: "cookies_types",
    },
    {
      id: "why_use_cookies",
      heading: t("why_use_cookies_heading", "Why do we use cookies?"),
      descriptionKey: "why_use_cookies",
    },
    {
      id: "other_tracking_technologies",
      heading: t(
        "other_tracking_technologies_heading",
        "What about other tracking technologies, like web beacons?",
      ),
      descriptionKey: "other_tracking_technologies",
    },
    {
      id: "cookie_policy_updates",
      heading: t(
        "cookie_policy_updates_heading",
        "How often will you update this Cookie Policy?",
      ),
      descriptionKey: "cookie_policy_updates",
    },
    {
      id: "detailed_cookie_info",
      heading: t(
        "detailed_cookie_info_heading",
        "Detailed information about cookies",
      ),
      descriptionKey: "detailed_cookie_info",
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        {/* Page Title */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              color: "#520A76",
              mb: 2,
            }}
          >
            {t("cookie_policy")}
          </Typography>
        </Box>

        {/* Policy Items List */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {policyItems.map((item) => (
            <Box key={item.id}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#520A76",
                  mb: 1.5,
                  fontSize: 18,
                }}
              >
                {item.heading}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#555",
                  lineHeight: 1.8,
                  fontSize: 14,
                }}
              >
                {t(item.descriptionKey)}
              </Typography>
            </Box>
          ))}

          {/* Contact Section - with clickable link */}
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#520A76",
                mb: 1.5,
                fontSize: 18,
              }}
            >
              {t(
                "cookie_contact_heading",
                "Where can I get further information?",
              )}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#555",
                lineHeight: 1.8,
                fontSize: 14,
              }}
            >
              {t(
                "cookie_contact_text",
                "If you have any questions about our use of cookies or other technologies, please email us at limousine@iyelo.com or visit:",
              )}
            </Typography>

            <Link
              to={
                t(
                  "cookie_contact_link",
                  "https://iyeloplus.com/en/contactUs",
                ) as string
              }
              target="_blank"
              rel="noopener noreferrer"
                style={{
                    color: "#520A76",
                    fontSize: 14,
                    textDecoration: "underline",
                    display: "inline-block",
                    marginTop: 8,
                }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.textDecoration = "underline")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.textDecoration = "none")
              }
            >
              {t("cookie_contact_link", "https://iyeloplus.com/en/contactUs")}
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CookiePolicy;
